<template>
	<div class="mobile-nav">
		<div class="mobile-nav-header flex-row">
			<img src="@/assets/img/logos/logo.svg" class="mobile-logo" alt="" @click="$router.push('/'); closeNavs()" :class="{ 'hidden-logo' : mobileNavToggle }">
			<div id="hamburger-icon" @click="toggleMobile()" :class="{ 'active-mobile' : mobileNavToggle }">
				<span class="line line-1"></span>
				<span class="line line-2"></span>
				<span class="line line-3"></span>
			</div>
			<transition name="mobile-nav-fade" mode="out-in">
				<div class="features-back" v-if="mobileNavFeaturesToggle || mobileNavResourcesToggle" @click="toggleMobileSubNav()">
					<svg version="1.1" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
					<polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "/>
					</svg>
				</div>
			</transition>
		</div>
		<div class="mobile-nav-content" :class="{ 'slide-in' : mobileNavToggle }">
			<p class="nav-link mobile-nav-link" @click="toggleFeaturesMobile()">features ></p>
			<router-link to="/pricing" class="nav-router">
				<p class="nav-link mobile-nav-link" @click="toggleMobile()">pricing</p>
			</router-link>
			<router-link to="/partners" class="nav-router">
				<p class="nav-link mobile-nav-link" @click="toggleMobile()">partners</p>
			</router-link>
			<!-- <p class="nav-link mobile-nav-link last" @click="toggleResourcesMobile()">resources ></p> -->
			<router-link to="/resources/blog" class="nav-router">
				<p class="nav-link mobile-nav-link" @click="toggleMobile()">blog</p>
			</router-link>
			<router-link to="/book-a-demo" class="nav-router">
				<button @click="closeNavs()">BOOK A DEMO</button>
			</router-link>
			<!-- <router-link to="/app-login" class="nav-router" target="_blank">
				<button @click="closeNavs()" class="inverted">LOGIN</button>
			</router-link> -->
		</div>
		<!-- MOBILE FEATURES -->
		<div class="mobile-nav-features-content" :class="{ 'slide-in-features' : mobileNavFeaturesToggle }">
			<router-link to="/features/recognition" class="nav-router">
				<div class="mobile-feature flex-row justify-start align-center">
					<img src="@/assets/img/icons/nav/recognition-icon.svg" alt="" class="feature-icon">
					<h1 @click="closeNavs()">Recognition</h1>
				</div>
			</router-link>
			<router-link to="/features/rewards" class="nav-router">
				<div class="mobile-feature flex-row justify-start align-center">
					<img src="@/assets/img/icons/nav/rewards-icon.svg" alt="" class="feature-icon">
					<h1 @click="closeNavs()">Rewards</h1>
				</div>
			</router-link>
			<router-link to="/features/trees" class="nav-router">
				<div class="mobile-feature flex-row justify-start align-center">
					<img src="@/assets/img/icons/nav/trees-icon.svg" alt="" class="feature-icon">
					<h1 @click="closeNavs()">Trees</h1>
				</div>
			</router-link>
			<div class="mobile-feature flex-row justify-start align-center half-opacity">
				<img src="@/assets/img/icons/nav/incentives-icon.svg" alt="" class="feature-icon">
				<h1 @click="closeNavs()">Incentives</h1>
				<p class="coming-soon-pill">coming soon</p>
			</div>
		</div>
		<!-- END MOBILE FEATURES -->
		<!-- MOBILE RESOURCES -->
		<div class="mobile-nav-features-content" :class="{ 'slide-in-features' : mobileNavResourcesToggle }">
			<router-link to="/resources/blog" class="nav-router">
				<div class="mobile-feature flex-row justify-start align-center">
					<img src="@/assets/img/icons/nav/blog-icon.svg" alt="" class="feature-icon">
					<h1 @click="closeNavs()">Blog</h1>
				</div>
			</router-link>
			<router-link to="/resources/library" class="nav-router">
				<div class="mobile-feature flex-row justify-start align-center">
					<img src="@/assets/img/icons/nav/library-icon.svg" alt="" class="feature-icon">
					<h1 @click="closeNavs()">Library</h1>
				</div>
			</router-link>
			<router-link to="/resources/news" class="nav-router">
				<div class="mobile-feature flex-row justify-start align-center">
					<img src="@/assets/img/icons/nav/news-icon.svg" alt="" class="feature-icon">
					<h1 @click="closeNavs()">News</h1>
				</div>
			</router-link>
		</div>
		<!-- END MOBILE RESOURCES -->
	</div>
</template>

<script>

	export default {
		data() {
			return {
				featuresToggle: false,
				resourcesToggle: false,
				mobileNavToggle: false,
				mobileNavFeaturesToggle: false,
				mobileNavResourcesToggle: false
			}
		},
		methods: {
			closeNavs() {
				this.featuresToggle = false;
				this.resourcesToggle = false;
				this.mobileNavFeaturesToggle = false;
				this.mobileNavResourcesToggle = false;
				this.mobileNavToggle = false;
				document.body.classList.remove("no-scroll");
			},
			toggleMobile() {
				this.mobileNavToggle = !this.mobileNavToggle;

				if (this.mobileNavToggle) {
					document.body.classList.add("no-scroll");
				} else {
					document.body.classList.remove("no-scroll");
				}
			},
			toggleFeaturesMobile() {
				this.mobileNavFeaturesToggle = !this.mobileNavFeaturesToggle;
			},
			toggleResourcesMobile() {
				this.mobileNavResourcesToggle = !this.mobileNavResourcesToggle;
			},
			toggleMobileSubNav() {
				this.mobileNavFeaturesToggle = false;
				this.mobileNavResourcesToggle = false;
			}
		},
	}
</script>

<style scoped lang="stylus">
	.mobile-nav
		display none

	@media ( max-width: 1100px )

		.mobile-nav
			display block
			
			.mobile-nav-header
				padding 20px
				background-color #fff
				width 100%

		.mobile-logo
			opacity 1
			transition all 0.25s ease
			
			&.hidden-logo
				opacity 0		
				pointer-events none
				
		#hamburger-icon 
			width 30px
			height 20px
			position relative
			display block
		
		#hamburger-icon .line 
			display block
			background #707070
			width 30px
			height 2px
			position absolute
			left 0
			transition all 0.25s
		
		#hamburger-icon .line.line-1 
			top 0
		
		#hamburger-icon .line.line-2 
			top 50%
		
		#hamburger-icon .line.line-3 
			top 100%
		
		#hamburger-icon.active-mobile .line-1 
			transform translateY(10px) translateX(1px) rotate(45deg)
			
		#hamburger-icon.active-mobile .line-2 
			opacity 0
			
		#hamburger-icon.active-mobile .line-3 
			transform translateY(-10px) translateX(0) rotate(-45deg)
			
		.mobile-nav-content
			position fixed
			width 100%
			height 100vh
			top 89px
			background-color #fff
			padding 50px 40px
			transform translateX(-100%)
			transition transform 0.25s ease
			
			&.slide-in
				transform translateX(0%)
				
			button
				width 200px
				margin-bottom 30px
				box-shadow none
				
		.mobile-nav-link
			font-size 40px
			font-weight 300
			padding-bottom 35px
			font-family baskerville-urw, serif
			text-transform capitalize
			
			&.last
				margin-bottom 60px
				
		.mobile-nav-features-content
			position fixed
			width 100%
			height 100vh
			top 89px
			background-color #fff
			padding 50px 40px
			transform translateX(-100%)
			transition transform 0.25s ease
			
			&.slide-in-features
				transform translateX(0%)
				
			.mobile-feature
				margin-bottom 34px
				h1
					font-size 44px
					font-weight	300
					margin-bottom 0
					
				img.feature-icon
					height 30px !important
					margin-right 20px
					
				.coming-soon-pill
					margin-left auto
					padding 4px 10px
					font-size 9px
					
		.features-back
			position absolute
			z-index 1000
			transform rotate(180deg)
			width 26px
</style>